import { useNavigate, useParams } from "react-router-dom";
import { useGetVideoQuizQuery } from "../../../features/Quiz/quizApi";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/Auth/selectAuth";
import { useAddQuizMarkMutation } from "../../../features/QuizMark/quizMarkApi";
import routes from "../../../config/routeConfig";

export default function Quiz() {
  const navigate = useNavigate();
  const loggedInUser = useSelector(selectUser);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const { videoId } = useParams();
  const {
    data: quizes,
    isLoading,
    isError: isGetVideoQuizError,
  } = useGetVideoQuizQuery(videoId);
  const [addQuizMark, { isSuccess, isError }] = useAddQuizMarkMutation();

  useEffect(() => {
    if (quizes?.length > 0) {
      setOptionsToState();
    }

    return () => {
      setSelectedOptions([]);
    };
  }, [quizes?.length]);

  useEffect(() => {
    if (isSuccess) {
      navigate(routes.student.leaderboard, { replace: true });
    } else if (isError) {
      alert("Failed to submit quiz, please try again!");
    }
  }, [isSuccess, isError]);

  const setOptionsToState = () => {
    const quizesStore = [];
    for (let i = 0; i < quizes?.length; i++) {
      const quiz = quizes[i];
      quizesStore.push({
        quizId: quiz.id,
        selectedOptionId: null,
      });
    }

    setSelectedOptions(quizesStore);
  };

  const handleOptionChange = (selectedQuestionId, selectedOptionId) => {
    const newSelectedOptions = [...selectedOptions];

    newSelectedOptions[selectedQuestionId].selectedOptionId =
      quizes[selectedQuestionId].options[selectedOptionId].id;

    setSelectedOptions(newSelectedOptions);
  };

  const handleQuizSubmit = (e) => {
    e.preventDefault();

    // check if user has selected all options
    for (let i = 0; i < selectedOptions.length; i++) {
      if (selectedOptions[i].selectedOptionId === null) {
        alert("Please select all options");
        return;
      }
    }

    // check if user has selected correct options
    let totalCorrect = 0;
    let totalWrong = 0;
    for (let i = 0; i < selectedOptions.length; i++) {
      const correctOption =
        quizes[i].options[selectedOptions[i].selectedOptionId - 1];
      if (correctOption.isCorrect) {
        totalCorrect += 1;
      } else {
        totalWrong += 1;
      }
    }

    const resultBody = {
      student_id: loggedInUser.student_id,
      student_name: loggedInUser.name,
      video_id: Number(videoId),
      video_title: quizes[0].video_title,
      totalQuiz: quizes.length,
      totalCorrect,
      totalWrong,
      totalMark: quizes.length * 5,
      mark: totalCorrect * 5,
    };

    addQuizMark(resultBody);
  };

  if (isGetVideoQuizError)
    return (
      <div className="text-red-400 text-center text-xl">
        Failed to load quiz, please try again!
      </div>
    );
  if (isLoading) return <div className="text-xl">Loading quiz...</div>;
  if (quizes?.length === 0)
    return <div className="text-center text-xl">No Quiz Found</div>;

  return (
    <>
      <div className="mb-8">
        <h1 className="text-2xl font-bold">{quizes[0]?.video_title}</h1>
        <p className="text-sm text-slate-200">Each question contains 5 Mark</p>
      </div>

      <div className="space-y-8 ">
        {quizes?.map((question, questionI) => (
          <div className="quiz" key={question.id}>
            <h4 className="question">
              Quiz {questionI + 1} - {question.question}
            </h4>
            <form className="quizOptions">
              {question.options?.map((option, optionI) => (
                <label
                  htmlFor={`option${optionI + 1}_q${questionI + 1}`}
                  key={option.id}
                  className={`${
                    selectedOptions[questionI]?.selectedOptionId === option.id
                      ? "active"
                      : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    id={`option${optionI + 1}_q${questionI + 1}`}
                    onChange={(e) => handleOptionChange(questionI, optionI)}
                  />
                  {option.option}
                </label>
              ))}
            </form>
          </div>
        ))}
      </div>

      <button
        onClick={handleQuizSubmit}
        className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 "
      >
        Submit
      </button>
    </>
  );
}
